import { IonIcon, IonItem, IonLabel } from "@ionic/react";
import React from "react";
import {
  chevronDownOutline as downIcon,
  chevronUpOutline as upIcon,
  checkmark,
} from "ionicons/icons";
import clsx from "clsx";

import folderIcon from "../../assets/icons/folder.svg";
import { TeacherGearboxDirectory } from "../../state";

import styles from "./BoxDirectorySelectForm.module.scss";

type BoxDirectorySelectFormProps = {
  isOpen: boolean;
  label?: string;
  teacherGearboxDirectories: TeacherGearboxDirectory[];
  selectedTeacherGearboxDirectoryIDs: number[];
  directoryName?: string;
  className?: string;
  onClick: () => void;
  update: (args: { [key: string]: any }) => void;
};

const BoxDirectorySelectForm = ({
  isOpen,
  label,
  teacherGearboxDirectories,
  selectedTeacherGearboxDirectoryIDs,
  directoryName,
  className,
  onClick,
  update,
}: BoxDirectorySelectFormProps) => {
  const isSelectedDirectory = (directoryId: number) =>
    selectedTeacherGearboxDirectoryIDs.includes(directoryId);

  const toggleDirectorySelection = (directoryId: number) => {
    const isSelected = isSelectedDirectory(directoryId);

    return isSelected
      ? selectedTeacherGearboxDirectoryIDs.filter(id => id !== directoryId)
      : [...selectedTeacherGearboxDirectoryIDs, directoryId];
  };

  const selectedDirectoriesList = teacherGearboxDirectories.filter(directory =>
    isSelectedDirectory(directory.id),
  );

  const selectedDirectories =
    selectedDirectoriesList.length === 0
      ? "未選択"
      : selectedDirectoriesList.map(c => c.name).join(", ");

  // COREの振り返りを含まないようにする
  const filterDirectories = (directories: TeacherGearboxDirectory[]) => {
    return directories.filter(c => c.klass_id === null);
  };

  return (
    <>
      <IonItem
        className={clsx(
          styles.directoryItemToggle,
          directoryName || "",
          className || "",
        )}
        onClick={onClick}
      >
        {label && (
          <IonIcon
            icon={folderIcon}
            color="light"
            slot="start"
            className={styles.folderIcon}
          />
        )}
        <IonLabel className={styles.title}>{label}</IonLabel>
        <div className={styles.selectedDirectories}>{selectedDirectories}</div>

        {isOpen ? (
          <IonIcon icon={upIcon} slot="end" className={styles.arrowIcon} />
        ) : (
          <IonIcon icon={downIcon} slot="end" className={styles.arrowIcon} />
        )}
      </IonItem>
      <div className={isOpen ? styles.directoryArea : styles.close}>
        {teacherGearboxDirectories.length === 0 ? (
          <div className={styles.noDirectories}>フォルダが見つかりません</div>
        ) : (
          <ul className={styles.directorySelector}>
            {filterDirectories(teacherGearboxDirectories).map(
              teacherGearboxDirectory => (
                <li
                  key={teacherGearboxDirectory.id}
                  className={clsx(
                    styles.directoryItem,
                    teacherGearboxDirectory.is_system && styles.isDisabled,
                  )}
                  onClick={() => {
                    if (teacherGearboxDirectory.is_system) return;

                    update({
                      selectedTeacherGearboxDirectoryIDs:
                        toggleDirectorySelection(teacherGearboxDirectory.id),
                    });
                  }}
                >
                  <div className={styles.directoryName}>
                    {teacherGearboxDirectory.name}
                    {isSelectedDirectory(teacherGearboxDirectory.id) && (
                      <IonIcon
                        slot="end"
                        icon={checkmark}
                        className={styles.checkIcon}
                      />
                    )}
                  </div>
                </li>
              ),
            )}
          </ul>
        )}
      </div>
    </>
  );
};

export default BoxDirectorySelectForm;
